const win = window;
const doc = document;
const Support =
(function Support() {
    const testDiv = doc.createElement('div');
    return {
        touch: win.Modernizr && win.Modernizr.touch === true || (function checkTouch() {
            return !!('ontouchstart' in win || win.DocumentTouch && doc instanceof win.DocumentTouch);
        }()),

        pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent),
        prefixedPointerEvents: !!win.navigator.msPointerEnabled,

        transition: (function checkTransition() {
            const style = testDiv.style;
            return 'transition' in style || 'webkitTransition' in style || 'MozTransition' in style;
        }()),
        transforms3d: win.Modernizr && win.Modernizr.csstransforms3d === true || (function checkTransforms3d() {
            const style = testDiv.style;
            return 'webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style;
        }()),

        flexbox: (function checkFlexbox() {
            const style = testDiv.style;
            const styles = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' ');
            for (let i = 0; i < styles.length; i += 1) {
                if (styles[i] in style) { return true; }
            }
            return false;
        }()),

        observer: (function checkObserver() {
            return 'MutationObserver' in win || 'WebkitMutationObserver' in win;
        }()),

        passiveListener: (function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get: function get() {
                        supportsPassive = true;
                    }
                });
                win.addEventListener('testPassiveListener', null, opts);
            } catch (e) {
                // No support
            }
            return supportsPassive;
        }()),

        gestures: (function checkGestures() {
            return 'ongesturestart' in win;
        }())
    };
}());

module.exports.support = Support;
module.exports.touchEvents = (function touchEvents() {
    const touch = ['touchstart', 'touchmove', 'touchend'];
    let desktop = ['mousedown', 'mousemove', 'mouseup'];
    if (Support.pointerEvents) {
        desktop = ['pointerdown', 'pointermove', 'pointerup'];
    } else if (Support.prefixedPointerEvents) {
        desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
    }
    const touchEventsTouch = {
        start: touch[0],
        move: touch[1],
        end: touch[2]
    };
    const touchEventsDesktop = {
        start: desktop[0],
        move: desktop[1],
        end: desktop[2]
    };
    return Support.touch ? touchEventsTouch : touchEventsDesktop;
}());


module.exports.device = (function Device() {
    const ua = win.navigator.userAgent;

    const device = {
        ios: false,
        android: false,
        androidChrome: false,
        desktop: false,
        windows: false,
        iphone: false,
        ipod: false,
        ipad: false,
        cordova: win.cordova || win.phonegap,
        phonegap: win.cordova || win.phonegap
    };

    var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    const ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);


    // Windows
    if (windows) {
        device.os = 'windows';
        device.osVersion = windows[2];
        device.windows = true;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.osVersion = android[2];
        device.android = true;
        device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // iOS
    if (iphone && !ipod) {
        device.osVersion = iphone[2].replace(/_/g, '.');
        device.iphone = true;
    }
    if (ipad) {
        device.osVersion = ipad[2].replace(/_/g, '.');
        device.ipad = true;
    }
    if (ipod) {
        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
        device.iphone = true;
    }
    // iOS 8+ changed UA
    if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
        if (device.osVersion.split('.')[0] === '10') {
            device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
        }
    }

    // Desktop
    device.desktop = !(device.os || device.android || device.webView);

    // Webview
    device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

    // Minimal UI
    if (device.os && device.os === 'ios') {
        const osVersionArr = device.osVersion.split('.');
        const metaViewport = doc.querySelector('meta[name="viewport"]');
        device.minimalUi =
            !device.webView &&
            (ipod || iphone) &&
            (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
            metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
    }

    // Pixel Ratio
    device.pixelRatio = win.devicePixelRatio || 1;

    // Export object
    return device;
}());


// WEBPACK FOOTER //
// ./js/utils/TouctSupport.js